<template>
	<div class="member-manage-container">
		<el-container class="outer-container">
			<el-header height="50px" class="top-header">
				<el-tabs v-model="activeTab" class="top-tabs">
					<el-tab-pane v-for="tab in tabs" :key="tab.name" :label="tab.label" :name="tab.name" />
				</el-tabs>
			</el-header>

			<el-container class="lower-container">
				<el-aside width="200px" class="aside">
					<div class="aside-header">
						<span>分组管理</span>
						<i class="el-icon-plus" @click="handleAddGroup"></i>
					</div>
					<el-menu :default-active="String(activeGroup)" class="group-menu" @select="handleGroupSelect">
						<el-menu-item v-for="g in groups" :key="String(g.id)" :index="String(g.id)">
							<span slot="title">{{ g.name }} ({{ g.count }})</span>
						</el-menu-item>
					</el-menu>
				</el-aside>

				<el-main class="main-body">
					<div class="content-wrapper">
						<div class="toolbar">
							<div class="filter-inputs">
								<el-input v-model="filters.query" placeholder="搜索昵称/信箱" prefix-icon="el-icon-search"
									size="small" style="width: 180px" clearable @clear="fetchData"
									@keyup.enter.native="fetchData" />

								<el-select v-model="filters.status" placeholder="线上状态" size="small" clearable
									@change="fetchData">
									<el-option label="在线" value="online" />
									<el-option label="离线" value="offline" />
									<el-option label="忙碌" value="busy" />
								</el-select>

								<el-date-picker v-model="filters.date" type="date" placeholder="最近登录时间" size="small"
									style="width: 150px" value-format="yyyy-MM-dd" @change="fetchData" />
							</div>

							<div class="action-btns">
								<el-button size="small" disabled>大量设定</el-button>
								<el-dropdown>
									<el-button type="primary" size="small">添加成员<i
											class="el-icon-arrow-down el-icon--right"></i></el-button>
									<el-dropdown-menu slot="dropdown">
										<el-dropdown-item @click.native="showAddDialog = true">手动添加</el-dropdown-item>
									</el-dropdown-menu>
								</el-dropdown>
							</div>

							<el-dialog :title="isEdit ? '编辑成员' : '添加成员'" :visible.sync="showAddDialog" width="540px"
								@close="resetAddForm" :modal="false">
								<el-form :model="addForm" label-width="100px" size="small" style="padding: 0 20px;">
									<el-form-item label="头像">
										<el-upload class="avatar-uploader" action="#" :auto-upload="false"
											:show-file-list="false" :on-change="handleAvatarChange">
											<img v-if="previewUrl" :src="previewUrl" class="avatar-img">
											<div v-else class="avatar-placeholder">
												<i class="el-icon-camera"></i>
											</div>
										</el-upload>
									</el-form-item>
									<el-form-item label="账号名">
										<el-input v-model="addForm.username" placeholder="请输入账号名" :disabled="isEdit" />
									</el-form-item>
									<el-form-item label="昵称">
										<el-input v-model="addForm.nickname" placeholder="昵称只在系统内展示，客户无法看到"
											maxlength="50" show-word-limit />
									</el-form-item>
									<el-form-item label="所属分组">
										<el-select v-model="addForm.group_ids" multiple placeholder="请选择所属分组"
											style="width: 100%">
											<el-option v-for="g in availableGroups" :key="String(g.id)" :label="g.name"
												:value="String(g.id)" />
										</el-select>
									</el-form-item>
									<el-form-item label="密码">
										<el-input v-model="addForm.password" placeholder="请输入密码" />
									</el-form-item>
									<el-form-item label="接待上限">
										<el-input-number v-model="addForm.max_num" :min="1" :max="9999"
											controls-position="right" />
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="showAddDialog = false">取 消</el-button>
									<el-button type="primary" @click="handleConfirmAdd" :loading="submitLoading">确
										定</el-button>
								</div>
							</el-dialog>

							<el-dialog title="新建分组" :visible.sync="showGroupDialog" width="460px"
								@close="resetGroupForm">
								<el-form :model="groupForm" label-position="top" size="small" style="padding: 0 10px;">
									<el-form-item label="名称" required>
										<el-input v-model="groupForm.name" placeholder="请输入分组名称" maxlength="30"
											show-word-limit />
									</el-form-item>
									<el-form-item label="描述">
										<el-input v-model="groupForm.desc" type="textarea" :rows="2"
											placeholder="请输入分组描述" maxlength="50" show-word-limit />
									</el-form-item>
									<el-form-item label="成员">
										<el-select v-model="groupForm.members" multiple placeholder="请选择分组内成员"
											style="width: 100%">
											<el-option v-for="item in tableData" :key="item.id" :label="item.nickname"
												:value="item.id" />
										</el-select>
									</el-form-item>
								</el-form>
								<div slot="footer" class="dialog-footer">
									<el-button @click="showGroupDialog = false">取 消</el-button>
									<el-button type="primary" @click="handleConfirmGroup"
										:loading="groupSubmitLoading">确 定</el-button>
								</div>
							</el-dialog>
						</div>

						<el-table :data="tableData" border size="small" class="member-table" v-loading="loading">
							<el-table-column type="selection" width="45" align="center" />
							<el-table-column label="昵称" width="180">
								<template slot-scope="{row}">
									<div class="user-cell">
										<el-avatar :size="28" :src="row.avatar" icon="el-icon-user-solid" />
										<div class="info">
											<div class="name">{{ row.nickname }}</div>
										</div>
									</div>
								</template>
							</el-table-column>
							<el-table-column prop="email" label="邮箱" minWidth="120">
								<template slot-scope="{row}">
									{{ row.email || '-' }}
								</template>
							</el-table-column>
							<el-table-column prop="max_num" label="接待上限" align="center" width="100" />
							<el-table-column prop="createtime" label="创建时间" width="150">
								<template slot-scope="{row}">
									{{ formatTime(row.createtime) }}
								</template>
							</el-table-column>
							<el-table-column label="在线状态" width="100">
								<template slot-scope="{row}">
									<span class="status-tag">
										<i class="dot" :class="row.status"></i>
										{{ formatStatusText(row.status) }}
									</span>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="120" fixed="right">
								<template slot-scope="{row}">
									<el-button type="text" size="small" @click="handleEdit(row)">编辑</el-button>
									<el-button type="text" size="small" class="danger-text">删除</el-button>
								</template>
							</el-table-column>
						</el-table>

						<el-pagination :current-page.sync="currentPage" :page-sizes="[10, 20, 50]"
							:total="tableData.length" layout="total, sizes, prev, pager, next, jumper"
							@size-change="fetchData" @current-change="fetchData" />
					</div>
				</el-main>
			</el-container>
		</el-container>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				activeTab: 'member',
				activeGroup: '0',
				currentPage: 1,
				showAddDialog: false,
				submitLoading: false,
				isEdit: false,
				currentEditId: '',
				previewUrl: '',
				group_ids: [],
				groupForm: {
					name: '',
					desc: '',
					members: []
				},
				addForm: {
					username: '',
					nickname: '',
					password: '',
					avatar: null,
					max_num: 1,
					group_id: ''
				},
				showGroupDialog: false,
				groupSubmitLoading: false,
				tabs: [{
						label: '人员管理',
						name: 'member'
					},
					{
						label: '角色管理',
						name: 'role'
					}
				],
				filters: {
					query: '',
					status: '',
					date: ''
				},
				groups: [],
				tableData: []
			};
		},

		mounted() {
			this.init();
		},
		computed: {
			// 过滤掉 ID 为 0 或 '0' 的分组，专门给下拉框用
			availableGroups() {
				return this.groups.filter(g => g.id !== 0 && g.id !== '0');
			}
		},
		methods: {
			async init() {
				await this.getGroupList();
				this.fetchData();
			},
			handleGroupSelect(index) {
				this.activeGroup = index;
				this.currentPage = 1;
				this.fetchData();
			},
			// 获取分组列表接口
			async getGroupList() {
				try {
					const res = await this.$axios.get(this.$apis.groupList);
					if (res && res.code === 1) {
						this.groups = res.data;
						if (this.groups.length > 0) {
							this.activeGroup = String(this.groups[0].id);
						}
					}
				} catch (error) {
					console.error("加载分组列表失败", error);
				}
			},

			async fetchData() {
				this.loading = true;
				try {
					const gid = (this.activeGroup === '0' || !this.activeGroup) ? '' : this.activeGroup;

					const p = {
						page: this.currentPage,
						keyword: this.filters.query || '',
						status: this.filters.status || '',
						search_time: this.filters.date || '',
						group_id: gid
					};

					const queryString =
						`page=${p.page}&keyword=${p.keyword}&status=${p.status}&search_time=${p.search_time}&group_id=${p.group_id}`;
					const url = `${this.$apis.getTeamList}?${queryString}`;

					const res = await this.$axios.get(url);
					if (res && res.code === 1) {
						this.tableData = res.data;
					}
				} catch (error) {
					console.error(error);
				} finally {
					this.loading = false;
				}
			},

			async handleConfirmGroup() {
				if (!this.groupForm.name) return this.$message.error('请填写分组名称');
				this.groupSubmitLoading = true;
				try {
					const submitData = {
						name: this.groupForm.name,
						desc: this.groupForm.desc,
						chat_ids: this.groupForm.members.join(',')
					};
					await this.$axios.post(this.$apis.addGroup, submitData);
					this.$message.success('分组新建成功');
					this.showGroupDialog = false;
					this.getGroupList();
				} catch (error) {
					this.$message.error('新建分组失败');
				} finally {
					this.groupSubmitLoading = false;
				}
			},

			handleAddGroup() {
				this.showGroupDialog = true;
			},

			resetGroupForm() {
				this.groupForm = {
					name: '',
					desc: '',
					members: []
				};
			},

			handleEdit(row) {
				this.isEdit = true;
				this.currentEditId = row.id;
				this.previewUrl = row.avatar || '';
				let safeGroupIds = [];
				if (Array.isArray(row.group)) {
					// 直接从对象数组里把 id 抽出来
					// 注意：el-select 匹配通常需要字符串类型的 ID，所以加个 String()
					safeGroupIds = row.group.map(item => String(item.id));
				}
				this.addForm = {
					username: row.username,
					nickname: row.nickname,
					password: '',
					max_num: row.max_num || 1,
					avatar: row.avatar,
					group_ids: safeGroupIds
				};
				this.showAddDialog = true;
			},

			resetAddForm() {
				this.isEdit = false;
				this.currentEditId = '';
				this.previewUrl = '';
				this.addForm = {
					username: '',
					nickname: '',
					password: '',
					avatar: null,
					max_num: 1,
					group_id: ''
				};
			},

			async handleConfirmAdd() {
				if (!this.addForm.username || !this.addForm.nickname) return this.$message.error('请填写完整信息');
				this.submitLoading = true;
				try {
					let avatarUrl = this.previewUrl;
					if (this.addForm.avatar instanceof File) {
						const uploadFd = new FormData();
						uploadFd.append('file', this.addForm.avatar);
						const uploadRes = await this.$axios.post(this.$apis.upload, uploadFd);
						avatarUrl = uploadRes.data.url || uploadRes.url;
					}
					const submitData = {
						...this.addForm,
						avatar: avatarUrl,
						group_ids: this.addForm.group_ids && this.addForm.group_ids.length > 0 ?
							this.addForm.group_ids.join(',') : ''
					};
					if (this.isEdit) {
						submitData.id = this.currentEditId;
						await this.$axios.post(this.$apis.editTeam, submitData);
					} else {
						await this.$axios.post(this.$apis.addTeam, submitData);
					}
					this.$message.success('操作成功');
					this.showAddDialog = false;
					this.fetchData();
					this.getGroupList();
				} catch (error) {
					this.$message.error('操作失败');
				} finally {
					this.submitLoading = false;
				}
			},

			handleAvatarChange(file) {
				this.previewUrl = URL.createObjectURL(file.raw);
				this.addForm.avatar = file.raw;
			},

			formatStatusText(status) {
				const statusMap = {
					'online': '在线',
					'offline': '离线',
					'busy': '忙碌'
				};
				return statusMap[status] || '离线';
			},

			formatTime(ts) {
				if (!ts) return '-';
				const date = new Date(ts * 1000);
				return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
			}
		}
	};
</script>

<style lang="scss" scoped>
	$primary: #409eff;

	.member-manage-container {
		height: 88vh;

		.outer-container {
			height: 100%;
		}
	}

	::v-deep .el-dialog {
		border-radius: 8px;

		.el-dialog__header {
			padding: 15px 20px;
			border-bottom: 1px solid #f0f0f0;

			.el-dialog__title {
				font-size: 16px;
				font-weight: bold;
			}
		}
	}

	.avatar-uploader {
		::v-deep .el-upload {
			border: 1px solid #d9d9d9;
			border-radius: 50%;
			width: 60px;
			height: 60px;
			display: flex;
			justify-content: center;
			align-items: center;

			&:hover {
				border-color: $primary;
			}
		}
	}

	.avatar-img {
		width: 60px;
		height: 60px;
		border-radius: 50%;
		object-fit: cover;
	}

	.status-tag {
		display: flex;
		align-items: center;
		gap: 4px;

		.dot {
			width: 8px;
			height: 8px;
			border-radius: 50%;

			&.online {
				background: #67c23a;
			}

			&.offline {
				background: #909399;
			}

			&.busy {
				background: #e6a23c;
			}
		}
	}

	.top-header {
		background: #fff;
		border-bottom: 1px solid #e6e6e6;
		display: flex;
		align-items: center;
	}

	.lower-container {
		height: calc(100% - 50px);
	}

	.aside {
		background: #fff;
		border-right: 1px solid #e6e6e6;

		.aside-header {
			padding: 15px 20px;
			display: flex;
			justify-content: space-between;
			font-weight: bold;
		}

		.group-menu {
			border-right: none;
		}
	}

	.main-body {
		padding: 0;
		background: #fff;

		.content-wrapper {
			padding: 15px;
			height: 100%;
			display: flex;
			flex-direction: column;
			gap: 15px;
			box-sizing: border-box;
		}
	}

	.toolbar {
		display: flex;
		justify-content: space-between;
		align-items: center;

		.filter-inputs {
			display: flex;
			gap: 8px;

			.el-select {
				width: 130px;
			}
		}
	}

	.member-table {
		flex: 1;

		.user-cell {
			display: flex;
			align-items: center;
			gap: 10px;

			.name {
				font-weight: 500;
			}
		}
	}

	.danger-text {
		color: #f56c6c;
	}
</style>